<template>
	<div class="pano-view" ref="viewer" @click="onPanoClick($event)" style="overflow: hidden;">
		<div v-for="(info, i) in info" :key="`info-${i}`" ref="info" class="info" @click.stop="$emit('info', $event, info)" @mouseleave.stop="onHotspotLeave($event)" @mousedown.stop="onHotspotDown($event)" @mouseup.stop="onHotspotUp($event)">
			<div class="icon"></div>
			<div class="marker"></div>
		</div>
		<div v-for="(nav, i) in navigation" :key="`nav-${i}`" ref="nav" class="navigation" @click.stop="onNavigate($event, nav)" @mouseleave.stop="onHotspotLeave($event)" @mousedown.stop="onHotspotDown($event)" @mouseup.stop="onHotspotUp($event)">
			<div class="icon">
				<svg-icon style="margin: 6px 0 0 6px; fill: white;" width="20px" height="20px" :icon="Object.prototype.hasOwnProperty.call(nav, 'icon') ? nav.icon : 'pano_person'" />
			</div>
			<div class="marker"></div>
		</div>
		<div class="copyright"></div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Marzipano from 'marzipano';

	export default {
		props: {
			value: {
				type: String,
				required: true
			},
			path: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				viewer: null,
				scenes: {},
				info: [],
				navigation: []
			};
		},
		watch: {
			async value(n) {
				(await this.getScene(n)).object.switchTo({
					transitionDuration: 1000
				});
			}
		},
		computed: {
			_options() {
				return {
					swfPath: 'swf/marzipano.swf'
				};
			}
		},
		methods: {
			async getScene(id) {
				if (!Object.prototype.hasOwnProperty.call(this.scenes, id)) {
					var i;

					const data 		= (await this.axios.get(`${this.path}${id}/config.json`)).data;
					const geometry 	= new Marzipano.CubeGeometry(data.levels);
					const source 	= Marzipano.ImageUrlSource.fromString(`scenes/${id}/{z}/{f}/{y}/{x}.jpg`, { cubeMapPreviewUrl: `scenes/${id}/preview.jpg` });
					const limiter 	= Marzipano.RectilinearView.limit.traditional(data.faceSize, 100 * Math.PI / 180, 120 * Math.PI / 180);
					const view 		= new Marzipano.RectilinearView(data.initialViewParameters, limiter);

					this.scenes[id] = {
						object: this.viewer.createScene({
							source: 		source,
							geometry: 		geometry,
							view: 			view,
							pinFirstLevel: 	true
						}),
						data: data
					};

					// Load info hotspots
					/*if (Object.prototype.hasOwnProperty.call(data, 'info')) {
						var info;

						for (i = 0; i < data.info.length; ++i) {
							info = data.info[i];

							this.info.push(info);
							await Vue.nextTick();

							console.log(info, this.$refs);

							this.scenes[id].object.hotspotContainer().createHotspot(this.$refs.info[this.info.length - 1], {
								yaw:	info.yaw, 
								pitch:	info.pitch
							}, {
								perspective: {
									extraTransforms: 'translate(-8px, -8px)'
								}
							});
						}
					}*/

					// Load navigation hotspots
					if (Object.prototype.hasOwnProperty.call(data, 'navigation')) {
						var nav;

						for (i = 0; i < data.navigation.length; ++i) {
							nav = data.navigation[i];

							this.navigation.push(nav);
							await Vue.nextTick();

							this.scenes[id].object.hotspotContainer().createHotspot(this.$refs.nav[this.navigation.length - 1], {
								yaw:	nav.yaw, 
								pitch:	nav.pitch
							}, {
								perspective: {
									extraTransforms: 'translate(-16px, -16px)'
								}
							});
						}
					}
				}

				return this.scenes[id];
			},
			async onPanoClick(event) {
				console.log('pano click', event);

				const view = (await this.getScene(this.value)).object._view;

				console.log(view.screenToCoordinates({
					x: event.clientX, 
					y: event.clientY
				}));
			},
			async onViewChange() {
				const view = (await this.getScene(this.value)).object._view;

				console.log({
					fov:	view._fov,
					yaw: 	view._yaw,
					pitch: 	view._pitch,
					roll: 	view._roll,
				});
			},
			onHotspotClick() {
				
			},
			onHotspotLeave(event) {
				event.currentTarget.classList.remove('clicked');
				this.onHotspotUp(event);
			},
			onHotspotUp(event) {
				event.currentTarget.classList.remove('down');
			},
			onHotspotDown(event) {
				const self = this;
				const el = event.currentTarget;

				el.classList.add('down');
				el.classList.add('clicked');

				setTimeout(function () {
					self.onHotspotLeave({
						currentTarget: el
					});
				}, 1000);
			},
			async onNavigate(event, nav) {
				this.$emit('navigate', event, nav);

				(await this.getScene(nav.id)).object.switchTo({
					transitionDuration: 1000
				});

				this.$emit('input', nav.id);
			}
		},
		async mounted() {
			this.viewer = new Marzipano.Viewer(this.$el, this._options);
			this.viewer.addEventListener('viewChange', this.onViewChange);

			// Set scene using hash
			const hash = location.hash;

			if (hash != '') {
				console.log("Use hash: ", hash);
				this.$emit('input', hash.substr(1));
			} else {
				console.log("No hash");

				(await this.getScene(this.value)).object.switchTo({
					transitionDuration: 1000
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.pano-view {
		background-color: #262626;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;

		::v-deep .info {
			& > .icon {
				transition: all 200ms ease-in-out;
				background-clip: padding-box;
				border-radius: 50%;
				height: 16px;
				width: 16px;

				background-color: #ff6600;

				border: 2px solid rgba(255, 255, 255, 0.9);

				cursor: pointer;

				box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
				transform: scale(1);
				animation: pulse 1500ms infinite;
			}

			& > .marker {
				transition: all 150ms ease-out;
				position: absolute;
				pointer-events: none;
				left: -39px;
				top: -39px;
				width: 96px;
				height: 96px;
				border-radius: 50%;
				border: 1px solid rgba(255, 255, 255, 0);
			}

			&:hover {
				& > .icon {
					animation: none;
				}

				& > .marker {
					transition-timing-function: ease-in;
					left: -13px;
					top: -13px;
					width: 36px;
					height: 36px;
					border-color: rgba(255, 255, 255, 0.5);
					border-width: 5px;
				}
			}

			&.down {
				& > .icon {
					transition: none;
					transform: scale(1.2);
				}
			}

			&.clicked {
				& > .marker {
					transition-timing-function: ease-out;
					left: -39px;
					top: -39px;
					width: 96px;
					height: 96px;
					border-color: rgba(255, 255, 255, 0);
					border-width: 1px;
				}
			}
		}

		::v-deep .navigation {
			& > .icon {
				transition: all 200ms ease-in-out;
				background-clip: padding-box;
				border-radius: 50%;
				height: 32px;
				width: 32px;

				background-color: #ff6600;

				border: 2px solid rgba(255, 255, 255, 0.9);

				cursor: pointer;

				box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
				transform: scale(1);
				animation: pulse 1500ms infinite;
			}

			& > .marker {
				transition: all 150ms ease-out;
				position: absolute;
				pointer-events: none;
				left: -39px;
				top: -39px;
				width: 112px;
				height: 112px;
				border-radius: 50%;
				border: 1px solid rgba(255, 255, 255, 0);
			}

			&:hover {
				& > .icon {
					animation: none;
				}

				& > .marker {
					transition-timing-function: ease-in;
					left: -13px;
					top: -13px;
					width: 52px;
					height: 52px;
					border-color: rgba(255, 255, 255, 0.5);
					border-width: 5px;
				}
			}

			&.down {
				& > .icon {
					transition: none;
					transform: scale(1.2);
				}
			}

			&.clicked {
				& > .marker {
					transition-timing-function: ease-out;
					left: -39px;
					top: -39px;
					width: 112px;
					height: 112px;
					border-color: rgba(255, 255, 255, 0);
					border-width: 1px;
				}
			}
		}

		::v-deep canvas {
			left: 0 ! important;
		}
	}

	@keyframes pulse {
		0% {
			transform: scale(1);
			box-shadow: 0 0 0 2px rgba(255, 255, 255, 0);
		}

		30% {
			transform: scale(0.85);
			box-shadow: 0 0 0 2px rgba(255, 255, 255, 0);
		}

		31% {
			transform: scale(1);
			box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.7);
		}

		100% {
			transform: scale(1);
			box-shadow: 0 0 0 16px rgba(255, 255, 255, 0);
		}
	}
</style>